<template>
  <a
    class="block py-1.5 px-3 text-gray-600 hover:text-gray-800"
    :class="{'text-gray-600': show, 'text-gray-400': !show}"
    v-if="show"
    href=""
    @click.stop.prevent="click">{{$t('Move to trash')}}</a>
</template>

<script>
import useBcFolderStore from '@/frontapp/store/bcFolder'
import { mapStores } from 'pinia'
import trash from '../../../mixins/actions/Trash'

export default {
  emits: ['onselect'],
  props: ['item'],
  computed: {
    show () {
      return this.bcFolderStore.current?.can_edit
    },
    ...mapStores(useBcFolderStore),
  },
  methods: {
    click() {
      const documentsIds = []
      const foldersIds = []

      if (this.item.type === 'document') {
        documentsIds.push(this.item.id)
      } else {
        foldersIds.push(this.item.id)
      }

      trash(documentsIds, foldersIds)
      this.$emit('onselect')
    }
  },
}
</script>

<style lang="scss" scoped></style>
